export default function FayettevilleARFinalCTA() {
  return (
    <section className="py-20 md:py-28 bg-[#1A365D]">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-5">Ready to Get Your Passport in Fayetteville, AR?</h2>
        <p className="text-white/70 text-lg max-w-2xl mx-auto mb-8">Whether you're a Razorback headed abroad or a corporate traveler flying to Bentonville's global partners, we've got you covered.</p>
        <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap">Start My Passport <i className="ri-arrow-right-line"></i></a>
        <p className="text-white/50 text-sm mt-6">Call us at <a href="tel:8772530084" className="text-[#F6C344] hover:underline">877-253-0084</a> for immediate assistance</p>
      </div>
    </section>
  );
}